const BASE = '/api';
const AUTH_BASE = process.env.REACT_APP_AUTH_URL || 'https://auth.velmushkin.com';

let accessToken = null;
let refreshPromise = null;

export function getAuthBase() {
  return AUTH_BASE;
}
export function saveToken(t) {
  accessToken = t;
}
export function clearToken() {
  accessToken = null;
}
export function getToken() {
  return accessToken;
}

export function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export async function refreshTokens() {
  if (refreshPromise) return refreshPromise;
  refreshPromise = fetch(`${AUTH_BASE}/api/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
  })
    .then(r => {
      if (!r.ok) throw new Error('Session expired');
      return r.json();
    })
    .then(data => {
      accessToken = data.accessToken;
      refreshPromise = null;
      return data;
    })
    .catch(err => {
      refreshPromise = null;
      accessToken = null;
      throw err;
    });
  return refreshPromise;
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

  let res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    credentials: 'include',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    try {
      await refreshTokens();
      headers['Authorization'] = `Bearer ${accessToken}`;
      res = await fetch(`${BASE}${path}`, {
        method,
        headers,
        credentials: 'include',
        body: body !== undefined ? JSON.stringify(body) : undefined,
      });
    } catch {
      window.dispatchEvent(new Event('auth:expired'));
      throw new Error('Session expired');
    }
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export const api = {
  getAccounts: () => request('GET', '/accounts'),
  addAccount: cfg => request('POST', '/accounts', cfg),
  deleteAccount: id => request('DELETE', `/accounts/${id}`),
  getBoxes: aid => request('GET', `/mail/${aid}/boxes`),
  getMessages: (aid, mailbox, page) =>
    request('GET', `/mail/${aid}/messages?mailbox=${encodeURIComponent(mailbox)}&page=${page}`),
  getMessage: (aid, uid, mailbox) =>
    request('GET', `/mail/${aid}/message/${uid}?mailbox=${encodeURIComponent(mailbox)}`),
  deleteMessage: (aid, uid, mailbox) =>
    request('DELETE', `/mail/${aid}/message/${uid}?mailbox=${encodeURIComponent(mailbox)}`),
  sendMail: (aid, msg) => request('POST', `/mail/${aid}/send`, msg),
};
